import React from 'react';

import {SecondaryTabs} from '@pb/kit-component-tabs-v2';

import {tabs2Level} from './tabs-2-level.module.styl';


type Props = {
    activeTab: string,
    setActiveTab: (tab: string) => void,
    children: React.ReactNode,
};

export const Tabs2Level = ({children, activeTab, setActiveTab}: Props) => (
    <SecondaryTabs value={activeTab} onChange={setActiveTab} className={tabs2Level} style={{width: '100%'}}>
        {children}
    </SecondaryTabs>
);
